import React from 'react';
import { DragLayer, DragLayerMonitor, XYCoord } from 'react-dnd';

import * as Types from 'types';

import { PlaylistArtworkPill } from 'playlists/components/PlaylistArtworkPill';

type Props = {
  playlistArtwork: Types.DraggedPlaylistArtwork;
  initialClientOffset: XYCoord | null;
  clientOffset: XYCoord | null;
};

// HOC DragLayer uses ref, can't be pure function.
class PlaylistArtworkPreview extends React.Component<Props> {
  /**
   * Preview component is absolutely positioned within relative parent.
   * Here we calculate distance dragged from parent's X/Y coordinates.
   */
  calculatePositionStyle() {
    const { playlistArtwork } = this.props;
    if (!playlistArtwork) {
      return {};
    }

    const { beginDragBounds } = playlistArtwork._meta;
    const { initialClientOffset, clientOffset } = this.props;
    const initialX = initialClientOffset ? initialClientOffset.x : 0;
    const initialY = initialClientOffset ? initialClientOffset.y : 0;
    let clientOffsetX = clientOffset ? clientOffset.x : 0;
    let clientOffsetY = clientOffset ? clientOffset.y : 0;

    clientOffsetX = clientOffsetX - initialX + beginDragBounds.left;
    clientOffsetY = clientOffsetY - initialY + beginDragBounds.top;

    const css: React.CSSProperties = {
      width: `${beginDragBounds.right - beginDragBounds.left}px`,
      transform: `translate(${clientOffsetX}px, ${clientOffsetY}px)`,
    };

    return css;
  }

  render() {
    const { playlistArtwork, clientOffset } = this.props;

    /**
     * props.playlistArtwork = monitor.getItem()
     * it can actually be any depending on what's being dragged.
     * Interestingly <Link /> is draggable and crashes the Preview
     * so we need to check if it's really a playlistArtwork
     */
    if (!playlistArtwork || !clientOffset || !playlistArtwork._meta) {
      return null;
    }

    return (
      <PlaylistArtworkPill
        className='artwork-pill--preview'
        playlistArtwork={playlistArtwork}
        style={this.calculatePositionStyle()}
      >
        <button className='artwork-pill__handle icon-button icon-burger' />
      </PlaylistArtworkPill>
    );
  }
}

const collect = (monitor: DragLayerMonitor) => ({
  playlistArtwork: monitor.getItem(),
  differenceFromInitialOffset: monitor.getDifferenceFromInitialOffset(),
  initialClientOffset: monitor.getInitialClientOffset(),
  getSourceClientOffset: monitor.getSourceClientOffset(),
  clientOffset: monitor.getClientOffset(),
});

export const PlaylistArtworkDraggablePreview = DragLayer(collect)(
  PlaylistArtworkPreview,
);
